export const BuildingIcon = () => {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2446_12932)">
        <path
          d="M2.375 0.5C1.33984 0.5 0.5 1.33984 0.5 2.375V18.625C0.5 19.6602 1.33984 20.5 2.375 20.5H6.125V17.375C6.125 16.3398 6.96484 15.5 8 15.5C9.03516 15.5 9.875 16.3398 9.875 17.375V20.5H13.625C14.6602 20.5 15.5 19.6602 15.5 18.625V2.375C15.5 1.33984 14.6602 0.5 13.625 0.5H2.375ZM3 9.875C3 9.53125 3.28125 9.25 3.625 9.25H4.875C5.21875 9.25 5.5 9.53125 5.5 9.875V11.125C5.5 11.4688 5.21875 11.75 4.875 11.75H3.625C3.28125 11.75 3 11.4688 3 11.125V9.875ZM7.375 9.25H8.625C8.96875 9.25 9.25 9.53125 9.25 9.875V11.125C9.25 11.4688 8.96875 11.75 8.625 11.75H7.375C7.03125 11.75 6.75 11.4688 6.75 11.125V9.875C6.75 9.53125 7.03125 9.25 7.375 9.25ZM10.5 9.875C10.5 9.53125 10.7812 9.25 11.125 9.25H12.375C12.7188 9.25 13 9.53125 13 9.875V11.125C13 11.4688 12.7188 11.75 12.375 11.75H11.125C10.7812 11.75 10.5 11.4688 10.5 11.125V9.875ZM3.625 4.25H4.875C5.21875 4.25 5.5 4.53125 5.5 4.875V6.125C5.5 6.46875 5.21875 6.75 4.875 6.75H3.625C3.28125 6.75 3 6.46875 3 6.125V4.875C3 4.53125 3.28125 4.25 3.625 4.25ZM6.75 4.875C6.75 4.53125 7.03125 4.25 7.375 4.25H8.625C8.96875 4.25 9.25 4.53125 9.25 4.875V6.125C9.25 6.46875 8.96875 6.75 8.625 6.75H7.375C7.03125 6.75 6.75 6.46875 6.75 6.125V4.875ZM11.125 4.25H12.375C12.7188 4.25 13 4.53125 13 4.875V6.125C13 6.46875 12.7188 6.75 12.375 6.75H11.125C10.7812 6.75 10.5 6.46875 10.5 6.125V4.875C10.5 4.53125 10.7812 4.25 11.125 4.25Z"
          fill="#2563EB"
        />
      </g>
      <defs>
        <clipPath id="clip0_2446_12932">
          <path d="M0.5 0.5H15.5V20.5H0.5V0.5Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
